// Importar dependencias
import numeral from "numeral";

// Darle formato a un número
const formatNumber = num => {
  if (!num) {
    return 0;
  }
  return numeral(Number(num)).format("0,0.000");
};

export { formatNumber };
